// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8413b09f","455":"579344f4"}[chunkId] + ".chunk.js";
};